import './App.css';
import Home from "./pages/Home";
import Footer from "./components/Common/Footer";
import NavBar from "./components/Common/NavBar";
import React from "react";
import {Route, Routes} from "react-router-dom";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import GasService from "./pages/GasService";
import ElectricalService from "./pages/ElectricalService";
import Login from "./pages/Login";
import GasSafetyRecord from "./pages/GasSafetyRecord";
import ProtectedRoute from "./components/Common/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { useLocation } from "react-router-dom";

const AppRoutes = () => {
    const location = useLocation();
    const hideFooter = location.pathname === '/gas-safety-record';

    return (
        <div className="App">
            <NavBar/>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/gallery" element={<Gallery/>}/>
                {/*<Route path="/about-us" element={<AboutUs/>}/>*/}
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/gas-service" element={<GasService/>}/>
                <Route path="/electric-service" element={<ElectricalService/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/gas-safety-record" element={
                    <ProtectedRoute><GasSafetyRecord/></ProtectedRoute>
                }/>
            </Routes>
            {!hideFooter && <Footer/>}
        </div>
    );
};

function App() {
    return (
        <AuthProvider>
            <AppRoutes />
        </AuthProvider>
    );
}

export default App;
